interface ItemProps {
  spacing: string
}

export const HorSpacerCustom = ({ spacing }: ItemProps) => <div className={spacing} />
